/**
 * Contém funções para tratamento, validação e preenchimento do formulário.
 *
 *    @author: Adalto Junior
 *    Date: 18/03/2013
 */


Monet.Form = {

    checkFormTemplate: function (entity) {

        const have_page_template = $("#" + entity + " #form_submenu_template");

        if (have_page_template.length === 0) {
            const $entity = $("#" + entity);
            $entity.html("");
            $entity.append(new Monet.UI.LayoutGenerator({
                items:[
                    {
                        attributes: {
                            "class": "span10 form_and_grid_generic",
                            "id": "form_and_grid"
                        }
                    },
                    {
                        attributes: {
                            "id": "form_submenu_template"
                        },
                        tag: "span"
                    }
            ]}).render());
        }
    }
    
};
